<template>
  <div class="debtorView-warpper">
    <nav-bar titleText="债务人" :rightText="rightText" rigthFontColor="#F9591B" titleWeight="bold" rightWeight="bold"
      rightSize="18px" :isFixed="true" @rightTextEvent=applyDebt @goBack="goBack"></nav-bar>

    <div class="contentBox">
      <div class="contentBox-box">
        <div class="left-img">
          <img :src="!debtor_info.member_logo ? agentimg : debtor_info.member_logo " alt />
        </div>
        <div class="right">
          <div class="title">{{debtor_info.member_realname}}</div>
          <div class="desc">{{debtor_info.member_mobile}}</div>
        </div>
      </div>
    </div>
    <div class="creditor-first-div">
      <div class="creditor-contact-service" v-if="list.length != 0" @click="chat">
        <span>遇到问题？</span>
        <span>联系客服，为您解答</span>
        <img src="../../../assets/debtor/right-arrow.png" alt="">
      </div>
      <p class="debt-order-title" v-if="list.length != 0">解债订单</p>

      <div class="refresh-btn" @click="refreshList">
        <img :src="reloadgrayicon" alt="">
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :style="pullStyle">
      <van-list v-model="loading" :finished="finished" :finished-text="this.list.length === 0 ? '' : '没有更多了'"
        @load="onLoad">
        <van-cell class="lists" v-for="(item, index) in list" :key="index">
          <div class="dataBody" @click="handleDebtor(item.id)">
            <div class="debtor_information">
              <div :class="[['待债权人确认','债权人驳回','平台驳回','待合同签名','待通过'].includes(item.status) ? 'color_org' : 'color_999']">
                {{item.status}}</div>
              <div class="status-box-right" v-if="item.status == '待债务人确认'" @click="handleDebtor(item.id)">
                <span>去确认</span>
              </div>
              <!-- <div class="creditorsIcon" v-if="item.creditor_details && item.creditor_details.member_avator"> -->
              <div class="creditorsIcon">
                <img :src="!item.creditor_details.member_avator ? agentimg : item.creditor_details.member_avator"
                  width="24" height="24" alt />
              </div>
              <div class="creditorsName">{{item.creditor_details && item.creditor_details.member_realname}}</div>
              <div class="clearBoth" />
              <p class="solutionMoney">解债金额</p>
              <p class="creditorsMoney">￥{{parseFloat(item.amount).toFixed(2)}} </p>
              <p class="agent">经纪人代码 {{item.agent_code}}</p>
            </div>
          </div>
        </van-cell>
        <!-- 暂无数据 -->
        <!-- <div class="empty" v-if="list.length == 0">
          <div class="emptyMsg" span="24">
            <img src="../../../assets/debtor/empty.png" width="100%" height="100%" />
            <p class="tip">暂无解债订单</p>
          </div>
        </div> -->
        <div class="empty" v-if="list.length === 0">
          <div class="emptyMsg" span="24">
            <p class="empet-text">您还未申请任何解债业务</p>
            <div @click.stop="grasp(2,$event)" class="server">
              <span>点我了解什么是债务人</span>
              <img src="../../../assets/debtor/righticon.png" alt="">
            </div>
            <van-button round type="info" size="large" @click="applyDebt">申请解债</van-button>
            <div class="creditor-contact-service" @click="chat">
              <span>遇到问题？</span>
              <span>联系客服，为您解答</span>
              <img src="../../../assets/debtor/right-arrow.png" alt="">
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="show1">
      <div class="grasp-debtor-box">
        <div class="title">{{show1Title}}</div>
        <div class="tips content" v-html="content1"></div>
        <p class="call-service content" @click="chat">点此联系解债业务客服></p>
        <div @click="show1 = false" class="van-hairline--top btn">知道了</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import navBar from "../components/navBar";
  export default {
    name: "debtorView",
    data() {
      return {
        list: [],
        debtor_info: {}, //基本信息
        loading: false,
        finished: false,
        refreshing: false,
        error: false,
        page: 0,
        pageSize: 10,
        show_pivot: false,
        statusColor: false,
        status: "",
        // 1：待审核，2：审核通过 ，-1：已驳回   
        companyStatus: 0,
        rejectReason: '',
        // rightText: '申请解债',
        pullStyle: {
          height: '500px'
        },
        show1: false,
        content1: '',
        show1Title: '债务人',
        agentLevel: '',
        agentimg: require('@/assets/debtor/actver.png'),
        reloadgrayicon: require('@/assets/debt/reload-gray-icon.png'),
      };
    },
    created() {
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      this.getCompanyStatus()
      this.getMenberInfo()
    },
    computed: {
      rightText() {
        return this.list.length ? '申请解债' : ''
      },
    },
    mounted() {
      this.pullStyle.height = document.body.clientHeight - (88 + 96 + 43 + 26) + 'px'
    },
    components: {
      navBar,
    },
    methods: {
      grasp(id, e) {
        e.stopPropagation()
        this.show1 = true;
        this.content1 = '';
        this.$api.post('debt/member/setting/get-content-setting', {
            id: id
          })
          .then((data) => {
            this.content1 = data.details
            this.show1Title = data.title
          })
      },
      refreshList() {
        if (!this.refreshing) {
          this.refreshing = true
          this.page = 0;
          this.onLoad();
        }
      },
      //联系客服跳原生
      chat() {
        this.showDialog = false
        this.params('18', '18', 'customerService')
      },
      getCompanyStatus() {
        this.$api.post('/debt/member/debtor-order/count').then(data => {
          // data.status = -1
          this.companyStatus = data.status
          this.rejectReason = data.reject_reason
          if ([1, -1].includes(data.status)) {
            this.rightText = ''
          }
        })
      },
      toSeaReason() {
        this.$router.push({
          path: '/debtRelief/resultAuthReject',
          query: {
            rejectReason: this.rejectReason
          }
        })
      },
      onLoad() {
        this.page++;
        this.getInfo();
      },
      onRefresh() {
        this.page = 0;
        this.onLoad();
      },
      getMenberInfo() {
        this.$api.post("debt/member/debtor/info")
          .then((res) => {
            this.debtor_info = res;
            // TODO  
            // this.isCompany = res.debtor_type == 2 ? true : false;
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            }
            return;
          });
      },
      getInfo() {
        this.$api
          .post("debt/member/debtor-order/list", {
            page: this.page,
            size: this.pageSize,
          })
          .then((res) => {
            const data = res.list;
            if (this.refreshing) {
              this.list = [];
              this.finished = false;
            }
            for (let i in data) {
              data[i].amount = (parseFloat(data[i].amount) + parseFloat(data[i].interest_amount)).toFixed(2)
              switch (data[i].status) {
                case 10:
                  data[i].status = "待债权人确认";
                  break;
                case 13:
                  data[i].status = "待债务人确认";
                  break;
                case 20:
                  data[i].status = "待债权人上传借据凭证";
                  break;
                case 23:
                  data[i].status = "待债务人上传打款凭证";
                  break;
                case 25:
                  data[i].status = "待平台审核";
                  break;
                case 30:
                  data[i].status = "待财务审核";
                  break;
                case 40:
                  data[i].status = "待合同审批";
                  break;
                case 50:
                  if (data[i].sign_role !== 2) {
                    data[i].status = "待合同签名";
                  } else {
                    data[i].status = "等待债权人签署合同";
                  }
                  break;
                case 60:
                  data[i].status = "债权回收中"; //债权人与债务人签名完成跳转到签名结果/agent/resultSignature
                  break;
                case 70:
                  data[i].status = "债权人驳回";
                  break;
                case 75:
                  data[i].status = "债务人驳回";
                  break;
                case 80:
                  data[i].status = "平台驳回";
                  break;
                case 85:
                  data[i].status = "财务驳回";
                  break;
                case 90:
                  data[i].status = "合同审批驳回";
                  break;
                case 100:
                  data[i].status = "合同撤回";
                  break;
                case 110:
                  data[i].status = "合同失效";
                  break;
                case 120:
                  data[i].status = "合同作废";
                  break;
                case 130:
                  data[i].status = "债权回收完成";
                  break;
                default:
                  data[i].status = "订单状态异常";
              }
              this.list.push(data[i]);
            }
            this.loading = false;
            if(res.list.length < this.pageSize){
              this.finished = true;
              this.refreshing = false;
            }
            if (this.refreshing) {
              this.$toast("刷新成功");
              this.refreshing = false;
            }
            // if (!this.finished && !this.loading && this.list.length <= 2) {
            //   this.onLoad();
            // }
          })
          .catch((err) => {
            this.loading = false;
            this.finished = true;
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            }
            return;
          });
      },
      //订单详情
      handleDebtor(id) {
        this.$router.push({
          path: "/debtor/detail",
          query: {
            order_id: id,
            debt_from: 'list',
          },
        });
      },
      goBack() {
        // this.$router.go(-1)
        this.$router.push({
          path: '/debtRelief/wrDebtPersonHome',
          query: {
            token: localStorage.getItem('_token') || this.$route.query.token,
          },
        })
      },
      //发表
      applyDebt() {
        this.$router.push({
          path: "/debtRelief/solutionDebtInfoDebtor",
        });

      },
    },
  };
</script>
<style lang="less">
  .debtorView-warpper {
    &::-webkit-scrollbar {
      display: none;
    }

    position: fixed;
    top: 0;
    left: 0;
    padding-top: 88px;
    width: 100%;
    box-sizing: border-box;

    background-color: #f5f6f7;
    height: 100%;
    color: #333;
    font-size: 14px;

    // .navbar {
    //   margin: 24px 5px 0 5px;
    // }
    .contentBox {
      margin-top: 12px;
      background: #fff;

      .contentBox-box {
        display: flex;
        align-items: center;

        .left-img {
          // display: flex;
          // align-items: center;
          width: 42px;
          height: 42px;
          margin: 21px 12px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 25px;
          }
        }

        .right {
          margin: 19px 0 18px;

          .title {
            height: 26px;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;
          }

          .desc {
            height: 21px;
            font-size: 13px;
            color: #999999;
            line-height: 21px;
          }
        }
      }
    }

    .creditor-contact-service {
      padding: 9px 12px 12px;
      display: flex;
      align-items: center;

      :nth-of-type(1) {
        height: 22px;
        font-size: 14px;
        color: #999999;
        line-height: 22px;
      }

      :nth-of-type(2) {
        height: 22px;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        margin-right: 6px;
      }

      img {
        width: 10px;
        height: 13px !important;
      }
    }

    p {
      height: 26px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
      padding: 0 12px;
    }

    .van-cell {
      padding: 0;
      line-height: normal;
      background-color: #f5f6f7;
    }

    .dataBody {
      background-color: #fff;
      margin: 12px 0 0;

      .debtor_information {
        padding: 12px 12px 15px;

        .color_org {
          color: #f9591b;
          font-weight: 600;
          font-size: 16px;
          width: 100%;
          padding-bottom: 12px;
          margin-bottom: 15px;
          border-bottom: 1px solid #eeeeee;
        }

        .color_999 {
          color: #999;
          font-weight: 600;
          font-size: 16px;
          width: 100%;
          padding-bottom: 12px;
          margin-bottom: 15px;
          border-bottom: 1px solid #eeeeee;
        }

        .title {
          font-weight: 600;
          font-size: 16px;
          width: 100%;
          padding-bottom: 12px;
          margin-bottom: 15px;
          border-bottom: 1px solid #eeeeee;
        }

        .creditorsIcon {
          // margin-right: 9px;
          float: left;

          img {
            border-radius: 30px;
          }
        }

        .creditorsName {
          margin-left: 9px;
          float: left;
          line-height: 27px;
        }

        .clearBoth {
          clear: both;
        }

        .solutionMoney {
          margin: 12px 0;
          padding-left: 0px;
        }

        .creditorsMoney {
          font-weight: 600;
          font-size: 24px;
          padding-left: 0px;
        }

        .agent {
          color: #ccc;
          margin: 9px 0 0;
          padding-left: 0px;
        }
      }

      .progress {
        margin: 12px 0;
      }
    }

    // .empty {
    //   margin: 64px 48px 0;
    //   .emptyMsg {
    //     text-align: center;
    //     width: 100%;
    //     height: 100%;
    //     // img {
    //     //   // width: 106px;
    //     //   // display: inline-block;
    //     // }
    //     .tip {
    //       color: #999;
    //       font-size: 16px;
    //       margin-top: 15px;
    //     }
    //   }
    // }
    .empty {
      width: 100%;
      margin-top: 42px;

      .emptyMsg {
        text-align: center;
        width: 100%;
        height: 100%;

        .empet-text {
          height: 26px;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
          margin-bottom: 5px;
        }

        .server {
          display: flex;
          align-items: center;
          width: fit-content;
          margin: 0 auto 42px;

          span {
            height: 21px;
            font-size: 13px;
            color: #2A62FC;
            line-height: 21px;
            margin-right: 8px;
          }

          img {
            width: 6px;
            height: 10px;
          }
        }

        .van-button--large {
          width: calc(100% - 54px);
        }

        .van-button--info {
          background-color: #FC740C;
          border: 1px solid #FC740C;

          .van-button__text {
            height: 28px;
            font-size: 17px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 28px;
          }
        }


        .creditor-contact-service {
          margin-top: 18px;
          display: flex;
          align-items: center;
          justify-content: center;

          :nth-of-type(1) {
            height: 22px;
            font-size: 14px;
            color: #999999;
            line-height: 22px;
          }

          :nth-of-type(2) {
            height: 22px;
            font-size: 14px;
            color: #666666;
            line-height: 22px;
            margin-right: 6px;
          }

          img {
            width: 10px;
            height: 13px !important;
          }
        }
      }
    }

    .van-pull-refresh {
      &::-webkit-scrollbar {
        display: none;
      }

      overflow-y: scroll;
    }

    .status-box-right {
      background: #FC740C;
      border-radius: 16px;
      text-align: center;
      padding: 4px 12px;
      position: absolute;
      top: 18px;
      right: 12px;

      span {
        height: 24px;
        font-size: 15px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 24px;
      }
    }

    .van-popup--center {

      width: calc(100% - 67px);
      border-radius: 10px;

      .grasp-debtor-box {
        padding: 20px 21px 0;

        .title {
          width: 100%;
          text-align: center;
          height: 25px;
          font-size: 18px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          margin-bottom: 8px;
        }

        .content {
          font-size: 15px;
          color: #333333;
          line-height: 24px;
        }

        .tips {
          p {
            height: initial;
            padding: 0;
            color: rgb(17, 31, 44) !important;
            font-weight: initial;
          }
        }

        .call-service {
          color: #2A62FC;
          margin-bottom: 18px;
          padding: 0;
          font-weight: initial;
        }

        .btn {
          width: 100%;
          height: 28px;
          font-size: 17px;
          font-weight: 700;
          color: #F9591B;
          line-height: 28px;
          padding: 11px 0;
          width: 100%;
          text-align: center;
        }
      }
    }

  }

  .creditor-first-div {
    position: relative;

    .refresh-btn {
      position: absolute;
      right: 12px;
      bottom: 2px;
      width: 24px;
      height: 24px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>